import { useState,useEffect } from 'react';
import styles from './General.module.css'
import { useRecoilState } from 'recoil';
import { namespaceState,namespaceDetailState } from '../../recoil/atoms';
import ToggleSwitch from '../../compoenets/ToggleSwitch';
import ConfirmModal from '../../compoenets/ConfirmModal';
import toUpperFirstCase from '../../utils/toUpperFirstCase';

export default function General(){
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [nsData,setNsData]=useRecoilState(namespaceDetailState);
    const [isConfirm,setIsConfirm]=useState(false);
    const adminRole="owner";

    const handleDelete=()=>{
        alert("아직 사용할 수 없는 기능입니다.😜")
    }

    return(
        <div className={styles['wrap']}>
            <div className={styles['item']}>
                <span>Creation Date</span>
                <span>{nsData.createdTime}</span>
            </div>
            {nsState.namespaceUserRoleName==adminRole&&
            <div className={styles['item']}>
                <span>Change Name</span>
                <input className={styles['input']}></input>
            </div>
            }
            <div className={styles['item']}>
                <span>Visibility</span>
                {nsState.namespaceUserRoleName==adminRole?
                <ToggleSwitch
                leftText="Public"
                rightText="Private"
                // checked={nsData.permission=="public"?false:true}
                />
                :
                <span>{nsData.permission&&toUpperFirstCase(nsData.permission)}</span>
                }
            </div>
            {nsState.namespaceUserRoleName==adminRole&&
            <div className={styles['item-delete']} onClick={()=>setIsConfirm(true)}>Delete Namespace</div>
            }
            {isConfirm&&<ConfirmModal
                title="Remove Namespace"
                subTitle={"Namespace `"+`${nsData.name}`+"`\n을 정말로 삭제하겠습니까?"}
                confirmText="Delete"
                cancelText="Cancel"
                onAction={handleDelete}
                onClose={()=>setIsConfirm(false)}
            />
        }
        </div>
    )

}